export default ['Bank', 'MFI', 'Umurenge Sacco', 'Sacco', 'Telco'];
